import { BillboardCarouselCommon } from './billboard-carousel-common';
import * as $ from 'jquery';

export const initBillboardCarousel = () =>

    $('[id^=billboard-carousel-]').each((i, bc) => {
        BillboardCarouselCommon.initSlick($(bc));
        //BillboardCarouselCommon.subscribeResize(() => { BillboardCarouselCommon.initSlick($(bc)); });
    })

